import Colors from 'constants/colors';
import { styled, TextField } from '@mui/material';

const customPropsList = ['width', 'isHighlighted'];
const getTextColor = (theme, isHighlighted) =>
    isHighlighted ? theme.palette.primary.main : Colors.BLACK_60_OPAQUE;

const getAdornmentColor = (theme, isHighlighted) =>
    isHighlighted ? theme.palette.primary.main : 'inherit';

const getColors = (theme, isHighlighted, error) => ({
    highlightBG: isHighlighted ? Colors.ACTIVE_FILTER_BG : Colors.WHITE,
    inputTextColor: error ? Colors.BLACK_87_OPAQUE : (isHighlighted ? theme.palette.primary.main : Colors.BLACK_30_OPAQUE),
    labelColor: error ? Colors.TEXT_ERROR : getTextColor(theme, isHighlighted),
    borderColor: error ? Colors.ERROR.BORDER : theme.palette.primary.main,
    adornmentColor: error ? Colors.ERROR.BORDER : getAdornmentColor(theme, isHighlighted),
});

const StyledTextField = styled(TextField, {
    shouldForwardProp: (prop) => !customPropsList.includes(prop),
})(({theme, width, isHighlighted, error}) => {
    const {
        highlightBG,
        inputTextColor,
        labelColor,
        borderColor,
        adornmentColor,
    } = getColors(theme, isHighlighted, error);

    return {
        width,
        '& .MuiInputLabel-root': {
            color: labelColor,
            overflow: 'visible',
        },
        // Label styles
        '& .MuiFormLabel-filled, .Mui-focused': {
            color: labelColor,
        },
        // Input base styles
        '& .MuiInputBase-root': {
            height: 38,
            color: Colors.BLACK_60_OPAQUE,
            fontSize: '14px',
            paddingRight: '10px',
            paddingLeft: '10px',
            cursor: 'pointer',
        },
        // Outlined input styles
        '& .MuiOutlinedInput-root': {
            backgroundColor: error ? Colors.WHITE : highlightBG,
            '&:hover fieldset': {
                borderColor: borderColor,
            },
            '& .MuiInputBase-input': {
                textAlign: 'left',
                paddingLeft: 0,
                color: inputTextColor,
            },
            '&.Mui-focused fieldset': {
                borderWidth: 1,
            },
            '& fieldset': {
                borderWidth: 1,
                borderColor: inputTextColor,
                fontSize: '15px',
            },
            '&.Mui-focused .MuiInputBase-input': {
                color: inputTextColor,
            },
            '&.Mui-focused .MuiInputAdornment-root svg': {
                color: adornmentColor,
            },
            '& .MuiTouchRipple-root': {
                display: 'none',
            },
            '& .MuiInputAdornment-positionStart > div': {
                display: 'flex',
                '& > svg': {
                    color: adornmentColor,
                },
            },
        },
        '& .MuiFormHelperText-root': {
           letterSpacing: '0.4px',
            color: Colors.ERROR.TEXT,
            fontSize: '12px',
        },
        '& .MuiAutocomplete-popupIndicator': {
            color: labelColor,
            fontSize: 22.286,
        },
    };
});

export default StyledTextField;